import { render, staticRenderFns } from "./StudentListPane.vue?vue&type=template&id=00137343&scoped=true&"
import script from "./StudentListPane.vue?vue&type=script&lang=ts&"
export * from "./StudentListPane.vue?vue&type=script&lang=ts&"
import style0 from "./StudentListPane.vue?vue&type=style&index=0&id=00137343&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00137343",
  null
  
)

export default component.exports